import { Component, OnInit, Input } from '@angular/core'
import { Router } from '@angular/router'
import { NgAnimateScrollService } from 'ng-animate-scroll'
import { NavService } from 'src/app/services/nav.service';

@Component({
  selector: 'app-network',
  templateUrl: './network.component.html',
  styleUrls: ['./network.component.scss']
})
export class NetworkComponent implements OnInit {
  public tickerInstances = [
    1, 2, 3, 4
  ]

  @Input() headline: string
  @Input() copy: string
  @Input() cta_url: string
  @Input() partners: any
  @Input() _editable: any
  constructor(
    private router: Router,
    private scroll: NgAnimateScrollService,
    private nav: NavService
  ) { }
  
  ngOnInit() {
  }

  // TODO: Speak to BK about the requirements for this function
  goToPartners() {
    this.scroll.scrollToElement('contact')
  }

  public onIntersection({ target, visible }, id): void {
    if(visible) {
      this.nav.changeActiveNavItem(id)
    }
  }
}
